import _ from 'underscore';

import Spinner from 'react-bootstrap/Spinner';

import 'bootstrap/dist/css/bootstrap.min.css';

function FullWidthSpinner({ text = 'Loading...', heightInVH = 100, scale = 1, additionalStyles = {} }) {
    const verticalBufferHeightInVH = Math.ceil(heightInVH * 0.2);
    const verticalImageHeightInVH = heightInVH - 2 * verticalBufferHeightInVH;

    // const imageSrc = '/loading-sundae.gif';
    const imageSrc = '/loading-banana-split.gif';

    const overlayBlockStyle = {
        zIndex: "99999",
        // height: "100vh",
        height: heightInVH,
        width: "100%",
        textAlign: "center",
        position: "absolute",
        // display: loading ? "block" : "none",
        display: 'block',
        // backgroundColor: rgba(0,0,0,0),
    }

    const imageStyle = _.extend({
        marginTop: `${verticalBufferHeightInVH}vh`,
        maxHeight: `${verticalImageHeightInVH}vh`,
        maxWidth: '75vw',
    }, additionalStyles);
      
    return (
        <>
            { text && (
                <div style={{
                    position:'absolute', top: `calc(${verticalBufferHeightInVH}vh - 2.5em)`,
                }}>
                    <div className='vertical-flex' style={{ width: '100vw' }}>
                        <div className='flex-justify-center'>
                            <p style={{fontSize: `${Math.pow(1.15, scale - 1)}em`}}>{text}</p>                        
                        </div>
                    </div>
                </div>
            )}

            <div style={overlayBlockStyle} >
                <img style={imageStyle} src={imageSrc} alt={text}/>
            </div>
        </>
    );
}

function FullWidthSpinnerSimple({ text = 'Loading...', heightInVH = 100, scale = 1 }) {
    const verticalBufferHeightInVH = Math.ceil((heightInVH - 10) / 2);
    return (
        <div style={{ height: `${heightInVH}vh`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
            <div style={{ height: `${verticalBufferHeightInVH}vh`, flex: '1 1 100vw', display: 'flex', justifyContent: 'center' }}>&nbsp;</div>
            <div style={{ flex: '1 0 100vw', display: 'flex', justifyContent: 'center', transform: `scale(${scale})` }}>
                <Spinner animation="border" size="large"/>
            </div>
            { text && (
                <div style={{ flex: '1 0 100vw', display: 'flex', justifyContent: 'center', marginTop: `${(scale - 1) * 18}px` }}>
                    <p style={{fontSize: `${Math.pow(1.15, scale - 1)}em`}}>{text}</p>
                </div>
            )}
            <div style={{ height: `${verticalBufferHeightInVH}vh`, flex: '1 1 100vw', display: 'flex', justifyContent: 'center' }}>&nbsp;</div>
        </div>
    );
}

export { FullWidthSpinner, FullWidthSpinnerSimple };
